import axios from 'axios'

const ResultsCall = {
  async patchActivityStatus(teacherCommentId) {
    if (!teacherCommentId) return

    const url = `${window.viewer.api}results/teacherComment/${teacherCommentId}/read`

    try {
      await axios.patch(url)
    } catch (error) {
      console.error('ResultsCall', error.message)
    }
  },
}

export default ResultsCall
